<div class="modal-header" appCustomAutofocus>
    <h3>Review - {{employee.FirstName}} {{employee.LastName}}</h3>
</div>
<div class="modal-body">
    <div *ngIf="existingMsg != null">
        <div class="alert alert-warning">{{existingMsg}}</div>
    </div>
    <div *ngIf="alert">
        <div [ngClass]="'alert alert-' + (alert.type || 'default')">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <div *ngIf="initMode">
        <div class="alert alert-info">Initializing this employee will create the HR Resource for this record, migrate all attachments and submitted information to Vista.</div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <label><strong>Email:</strong></label>
            <br />
            {{employee.Email}}
        </div>
        <div class="col-lg-6">
            <label><strong>Progress</strong></label>
            <div class="progress" *ngIf="employee.TasksCompleted !== 'In Process' && employee.TasksCompleted !== 'Completed'">
                <div class="progress-bar" role="progressbar" attr.aria-valuenow="{{employee.TasksCompleted}}" attr.aria-valuemin="0" attr.aria-valuemax="{{employee.TasksTotalCount}}" [style.width]="employee.PercentComplete + '%'">
                    <span>{{employee.TasksCompleted}} / {{employee.TasksTotalCount}}</span>
                </div>
                <div *ngIf="employee.PercentComplete == null || employee.PercentComplete == 0" style="text-align: center; width: 100%; margin: auto;">
                    {{employee.TasksCompleted}} / {{employee.TasksTotalCount}}
                </div>
            </div>
            <div *ngIf="employee.TasksCompleted === 'In Process' || employee.TasksCompleted === 'Completed'">{{employee.TasksCompleted}}</div>
        </div>
    </div>
    <div class="row" *ngIf="employee.TasksCompleted !== 'In Process' && employee.TasksCompleted !== 'Completed'">
        <div class="col-lg-6">
            <label><strong>Date Initiated:</strong></label>
            <div>{{employee.DateInitiatedDisplay}}</div>
        </div>
        <div class="col-lg-6">
            <label><strong>PIN:</strong></label>
            <br />
            {{employee.IdentityKey}}
        </div>
    </div>
    <div class="row" style="margin-top:12px;" [hidden]="initMode" *ngIf="employee.TasksCompleted !== 'In Process' && employee.TasksCompleted !== 'Completed'">
        <div class="col-lg-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>Task:</th>
                        <th>Status:</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let task of tasks">
                        <td>
                            <a [href]="downloadDocument(task)" *ngIf="task.OnboardTaskDateCompleted != null && task.OnboardBulletinID != null" target="_blank">{{task.OnboardTaskName}}</a>
                            <a [href]="downloadChecklist(task)" target="_blank"
                               *ngIf="task.OnboardTaskDateCompleted != null && task.OnboardChecklistInstanceID != null">
                                {{task.OnboardTaskName}}
                            </a>
                            <span *ngIf="task.OnboardTaskDateCompleted == null">{{task.OnboardTaskName}}</span>
                        </td>
                        <td>
                            <span *ngIf="task.OnboardTaskDateCompleted == null">Incomplete</span>
                            <span *ngIf="task.OnboardTaskDateCompleted != null">Completed on {{task.TaskCompletedDisplay}}</span>
                        </td>
                        <td>
                            <button type="button" class="btn btn-danger" *ngIf="!task.ConfirmDelete" (click)="deleteTask(task)">
                                Delete
                            </button>
                            <button type="button" class="btn btn-danger" *ngIf="task.ConfirmDelete" (click)="confirmDeleteTask(task)">
                                Confirm
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row" style="margin-top: 12px;" *ngIf="initMode">
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>HR Company </strong> <span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.HRCo" (ngModelChange)="hrcoUpdate()" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let hrCompany of hrCompanies" [value]="hrCompany">{{hrCompany.CompanyName}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Expected Hire Date: </strong><span style="color:red;">*</span></label>
            <div class="input-group">
                <input type="text"
                       class="form-control"
                       bsDatepicker
                       #exphiredp="bsDatepicker"
                       [(ngModel)]="formData.hireDate"
                       [outsideClick]="true"
                       [bsConfig]="datePickerOptions"
                       [readonly]="mobileMode"
                       style="background-color:#ffffff;">
                <div class="input-group-append">
                    <button type="button" class="btn btn-outline-secondary"
                            (click)="exphiredp.show()"
                            [attr.aria-expanded]="exphiredp.isOpen">
                        <i class="modus-icons align-bottom">calendar</i>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Gender </strong><span style="color:red;">*</span></label>
            <ng-select [searchable]="false" [clearable]="false"
                       [(ngModel)]="formData.Gender">
                <ng-option value="M">M - Male</ng-option>
                <ng-option value="F">F - Female</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4">
            <label><strong>Auto Generate HR Ref</strong></label>
            <input type="checkbox" class="form-control" style="width:25px;" [(ngModel)]="formData.autoRef" (ngModelChange)="autoRefChange()" />
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>HR Ref </strong><span style="color:red;">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="formData.hrRef" [disabled]="formData.autoRef" (ngModelChange)="checkMaxLength()" [ngClass]="{invalidField: formData.hrRefDisable}" />
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Race </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.Race" [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let data of raceList" [value]="data.Race">{{data.Race + ' - ' + data.Description}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Hourly Wage / Salary Amt.</strong></label>
            <input currencyMask [options]="options" [(ngModel)]="formData.Wage" type="text" class="form-control" />
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Time Rev Group</strong></label>
            <ng-select [(ngModel)]="formData.timesheetRevGroup" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let data of timeRevList" [value]="data.ReviewerGroup">{{data.ReviewerGroup}} - {{data.Description}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>PRCo </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.PRCo" (ngModelChange)="pRCoChanged()" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let prCompany of prCompanies" [value]="prCompany.PRCo">{{prCompany.PRCoNameMask}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>PR Group </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.PRGroup" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let pRGroup of pRGroups" [value]="pRGroup.PRGroup">{{pRGroup.PRGroupName}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Insurance Code </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.InsCode" [searchable]="false" [clearable]="false">
                <ng-option *ngFor="let data of insuranceCodeList" [value]="data.InsCode">{{data.InsCode + ' - ' + data.Description}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Craft</strong></label>
            <ng-select [(ngModel)]="formData.Craft" (ngModelChange)="craftChanged()" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let craft of crafts" [value]="craft.Craft">{{craft.Craft}} - {{craft.CraftDescription}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>Class</strong></label>
            <ng-select [(ngModel)]="formData.Class" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let class of classes" [value]="class.Class">{{class.ClassDescription}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4" style="margin-bottom:5px;">
            <label><strong>PR Department </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.PRDept" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let department of departments" [value]="department.PRDept">{{department.PRDept}} - {{department.PRDeptDescription}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-4">
            <label><strong>Default Earn Code </strong><span style="color:red;">*</span></label>
            <ng-select [(ngModel)]="formData.EarnCode" [searchable]="true" [clearable]="false">
                <ng-option *ngFor="let earnCode of earnCodes" [value]="earnCode.EarnCode">{{earnCode.EarnCode}} - {{earnCode.EarnCodeDescription}}</ng-option>
            </ng-select>
        </div>
    </div>
    <div *ngIf="initMode">
        <label style="margin-top: 12px;margin-left:15px;"><strong>Attachments:</strong></label>
        <div *ngFor="let file of newFiles" style="margin-top: 20px">
            {{file.Filename}}
            <button class="btn btn-danger" (click)="deleteAttachment(file)" *ngIf="file.File != null && file.Progress == null">
                <i class="modus-icons" aria-hidden="true">delete</i>
            </button>
            <div style="padding-left:15px;margin-top:5px;">
                <div class="progress" style="width:250px;" *ngIf="file.Progress > 0">
                    <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
                </div>
            </div>
        </div>
        <div [ngClass]="{dflex: !mobileMode}">
            <div ngfDrop multiple="1" selectable="1" [(validDrag)]="validComboDrag"
                 [(files)]="formData.fileDrop" name="attachment" style="width: 200px;"
                 accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx,.mov,.mp4,.wmv"
                 [(dragFiles)]="dragFiles" class="drop-box" [class.invalid-drag]="validComboDrag===false"
                 [class.valid-drag]="validComboDrag" (filesChange)="upload()" [ngfFixOrientation]="false">
                Drop a file or Click to upload
            </div>
            <div>
                <div *ngFor="let file of savedFiles" style="margin-bottom: 15px;">
                    <a href="/Document/GetVCMAttachment?contentTypeName={{file.VCMContentType}}&docID={{file.VCMDocID}}&filename={{file.Description}}" *ngIf="file.VCMDocID != null">{{file.AttachmentFileName}}</a>
                    <a href="/Document/GetDBAttachment?attachmentID={{file.FileAttachmentID}}" *ngIf="file.VCMDocID == null">{{file.AttachmentFileName}}</a>
                    <a [href]="" (click)="deleteAttachment(file)" style="cursor: pointer;">
                        <span style="color:red;"> (remove)</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer d-block">
    <div class="row" *ngIf="!initMode">
        <div class="col-lg-12">
            <button type="button" [hidden]="deleteMode" class="float-left btn btn-success mb-1" (click)="sendReminder()" *ngIf="employee.TasksCompleted !== 'In Process' && employee.TasksCompleted !== 'Completed'">Send Reminder</button>
            <button type="button" [hidden]="deleteMode" class="btn btn-primary float-right mb-1" (click)="toggleInitialize()" [disabled]="processing" *ngIf="!initMode && onAdmin">
                Ready to Initialize <i class="modus-icons align-bottom">chevron_right_thick</i>
            </button>
            <button type="button" class="btn btn-outline-dark float-right mb-1" (click)="closeClicked()">Close</button>
            <button type="button" [hidden]="deleteMode" class="btn btn-danger float-right mb-1" (click)="deleteMode = true" [disabled]="processing" *ngIf="employee.TasksCompleted !== 'In Process' && employee.TasksCompleted !== 'Completed'">Delete</button>
            <button type="button" *ngIf="deleteMode" class="btn btn-outline-dark float-right mb-1" (click)="deleteMode = false" [disabled]="processing">Cancel Delete</button>
            <button type="button" *ngIf="deleteMode" class="btn btn-danger float-right mb-1" (click)="confirmDelete()" [disabled]="processing">Confirm Delete</button>
        </div>
    </div>
    <div class="row" style="margin-top: 12px;" *ngIf="initMode">
        <div class="col-lg-12">
            <button type="button" class="btn btn-outline-dark float-right" (click)="closeClicked()">Close</button>
            <button type="button" class="btn btn-success float-right" (click)="initializeBirdDog()"
                    *ngIf="onAdmin && (employee.TasksCompleted === 'In Process' || employee.TasksCompleted === 'Completed')"
                    [disabled]="formData.HRCo == null || formData.hireDate == null || processing || (formData.hrRef == null && !formData.autoRef) || formData.Gender == null || formData.InsCode == null
                    || formData.PRCo == null || formData.Race == null || formData.PRDept == null || formData.PRGroup == null || formData.hrRefDisable">
                Initialize
            </button>
            <span class="float-right" *ngIf="processing">
                Processing... <img src="/Cache/images/icon_load.gif" alt="Loading..." />
            </span>
        </div>
    </div>
</div>
